import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AccountingComponent} from './accounting.component';
import {AutoCompleteModule, DialogModule, MultiSelectModule} from 'primeng/primeng';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {FormsModule} from '@angular/forms';
import {CollapseModule, ModalModule} from 'ngx-bootstrap';
import {HttpModule} from '@angular/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LayoutModule} from '../layout/layout.module';
import {routing} from './accounting.routing';
import { PayoutsModule } from './payouts/payouts.module';

@NgModule({
    imports: [
        CommonModule, routing, SharedTranslationModule,
        FormsModule,
        HttpModule,
        DialogModule,
        SharedTranslationModule,
        AutoCompleteModule,
        BrowserAnimationsModule,
        MultiSelectModule,
        LayoutModule,
        PayoutsModule,
        CollapseModule.forRoot(),
        ModalModule.forRoot()
    ],
    declarations: [AccountingComponent]
})
export class AccountingModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/accounting/accounting.module.ts